import React, { useEffect, useState, createElement } from 'react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { Modal } from './ui/Modal';
import { CheckCircle2, Clock, Flame, Utensils, ChefHat, ShoppingBag, BookOpen, Calendar, ArrowRight, X, Check, Star } from 'lucide-react';
export function SalesPage() {
  const productImageUrl = 'https://cdn.magicpatterns.com/uploads/2YBk4SRsq8Vi6ufDAGXJVm/Foto_portada.png';
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  // Meta Pixel initialization + PageView
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
      ;
      (window as any).fbq('init', '1419898916457047');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  const handleBuyClick = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Método 3 Bases + 5 Variaciones',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    window.open('https://multidigitalhub.com/cart/43564997247041:1', '_blank');
  };
  const scrollToOffer = () => {
    const element = document.getElementById('pricing');
    if (element) element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <div className="min-h-screen bg-[#FDFCF8] font-sans text-stone-800 selection:bg-emerald-100 selection:text-emerald-900" data-id="element-1">
      {/* Navigation / Logo Area */}
      <nav className="w-full py-4 px-6 border-b border-stone-100 bg-white/80 backdrop-blur-md sticky top-0 z-50" data-id="element-2">
        <div className="max-w-5xl mx-auto flex justify-between items-center" data-id="element-3">
          <div className="font-serif text-xl font-bold text-emerald-800 tracking-tight" data-id="element-4">
            Método 3+5
          </div>
          <Button variant="primary" size="sm" onClick={scrollToOffer} data-id="element-5">
            Obtener el Método
          </Button>
        </div>
      </nav>

      {/* HERO SECTION */}
      <header className="relative pt-12 pb-20 px-4 overflow-hidden" data-id="element-6">
        <div className="max-w-5xl mx-auto" data-id="element-7">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-8">
            <div className="flex-1 text-center md:text-left z-10" data-id="element-9">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-sm font-semibold mb-6" data-id="element-10">
                <Flame className="w-4 h-4" data-id="element-11" />
                <span data-id="element-12">Baja grasa sin contar calorías</span>
              </div>
              <h1 className="font-serif text-4xl md:text-6xl font-bold text-stone-900 leading-[1.1] mb-6" data-id="element-13">
                Deja de{' '}
                <span className="text-emerald-600 italic" data-id="element-14">"improvisar"</span> la
                cena
              </h1>
              <p className="text-xl text-stone-600 mb-8 leading-relaxed max-w-lg mx-auto md:mx-0" data-id="element-15">
                El sistema simple para gente ocupada que quiere comer bien,
                bajar grasa y dejar de pedir delivery por cansancio.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-16">
                <Button size="lg" onClick={scrollToOffer} className="shadow-emerald-200/50" data-id="element-17">
                  Descargar el Método
                  <ArrowRight className="ml-2 w-5 h-5" data-id="element-18" />
                </Button>
                <div className="flex items-center justify-center gap-2 text-sm text-stone-500 py-3" data-id="element-19">
                  <Clock className="w-4 h-4" data-id="element-20" />
                  <span data-id="element-21">Cenas en 15 min</span>
                </div>
              </div>
            </div>
            <div className="flex-1 relative" data-id="element-22">
              <div className="absolute inset-0 bg-gradient-to-tr from-emerald-100 to-orange-50 rounded-full blur-3xl opacity-60 transform scale-90" data-id="element-23"></div>
              <img src={productImageUrl} alt="Método 3 Bases + 5 Variaciones en laptop y tablet con comida saludable" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-24" />
            </div>
          </div>
        </div>
      </header>

      {/* THE PROBLEM (Lead) */}
      <section className="py-20 px-4 bg-white" data-id="element-25">
        <div className="max-w-2xl mx-auto" data-id="element-26">
          <div className="prose prose-lg prose-stone mx-auto" data-id="element-27">
            <p className="font-serif text-2xl md:text-3xl text-stone-900 font-medium leading-snug mb-8" data-id="element-28">
              Llegas a casa tarde. Estás cansado.
            </p>
            <p data-id="element-29">Abres la nevera. Cierras la nevera.</p>
            <p data-id="element-30">Miras el teléfono… y de repente ya estás pidiendo algo.</p>
            <p data-id="element-31">No porque seas débil.</p>
            <p className="font-semibold text-stone-900 bg-stone-50 p-4 rounded-lg border-l-4 border-orange-400" data-id="element-32">
              Porque a esa hora no tienes energía para decidir.
            </p>
            <p data-id="element-33">
              Y ahí es donde la mayoría pierde: no en el gimnasio, no en la
              teoría…
              <span className="block mt-2 font-bold text-xl text-red-500" data-id="element-34">
                en la cena improvisada.
              </span>
            </p>

            <div className="my-12 p-8 bg-stone-50 rounded-2xl border border-stone-100" data-id="element-35">
              <h3 className="font-serif text-2xl font-bold mb-4 text-stone-900" data-id="element-36">
                La verdad incómoda
              </h3>
              <p className="mb-4" data-id="element-37">
                No te falta información. Te falta un <strong data-id="element-38">sistema</strong>{' '}
                que funcione cuando estás cansado.
              </p>
              <p data-id="element-39">
                Porque en la mañana todos somos "disciplinados". Pero en la
                noche, después de trabajar todo el día… tu cerebro solo quiere:
              </p>
              <ul className="space-y-2 mt-4" data-id="element-40">
                <li className="flex items-center gap-3" data-id="element-41">
                  <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 flex-shrink-0" data-id="element-42">
                    <Check className="w-4 h-4" data-id="element-43" />
                  </div>
                  <span data-id="element-44">Rapidez</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-45">
                  <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 flex-shrink-0" data-id="element-46">
                    <Check className="w-4 h-4" data-id="element-47" />
                  </div>
                  <span data-id="element-48">Sabor</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-49">
                  <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 flex-shrink-0" data-id="element-50">
                    <Check className="w-4 h-4" data-id="element-51" />
                  </div>
                  <span data-id="element-52">Cero esfuerzo</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* THE SOLUTION REVEAL */}
      <section className="py-24 px-4 bg-stone-900 text-white relative overflow-hidden" data-id="element-53">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-54">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-500 rounded-full blur-3xl" data-id="element-55"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-orange-500 rounded-full blur-3xl" data-id="element-56"></div>
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-57">
          <span className="uppercase tracking-widest text-emerald-400 font-bold text-sm mb-4 block" data-id="element-58">
            Presentando
          </span>
          <h2 className="font-serif text-4xl md:text-6xl font-bold mb-8" data-id="element-59">
            Método <span className="text-emerald-400" data-id="element-60">3 Bases</span> +{' '}
            <span className="text-orange-400" data-id="element-61">5 Variaciones</span>
          </h2>
          <p className="text-xl text-stone-300 max-w-2xl mx-auto mb-16" data-id="element-62">
            No es un recetario infinito. Es un piloto automático. Airfryer y
            cocina tradicional para que funcione en tu casa, no en Pinterest.
          </p>

          <div className="grid md:grid-cols-2 gap-8 text-left" data-id="element-63">
            {/* 3 BASES */}
            <div className="bg-stone-800/50 backdrop-blur-sm p-8 rounded-2xl border border-stone-700" data-id="element-64">
              <div className="flex items-center gap-3 mb-6" data-id="element-65">
                <div className="p-3 bg-emerald-500/20 rounded-xl text-emerald-400" data-id="element-66">
                  <Utensils className="w-6 h-6" data-id="element-67" />
                </div>
                <h3 className="text-2xl font-bold" data-id="element-68">3 Bases</h3>
              </div>
              <p className="text-stone-400 mb-6 text-sm uppercase tracking-wider" data-id="element-69">
                Estructuras que no fallan
              </p>
              <ul className="space-y-4" data-id="element-70">
                <li className="flex items-start gap-3" data-id="element-71">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-stone-700 text-sm font-bold" data-id="element-72">
                    1
                  </span>
                  <span className="text-lg" data-id="element-73">Bowl de proteína</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-74">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-stone-700 text-sm font-bold" data-id="element-75">
                    2
                  </span>
                  <span className="text-lg" data-id="element-76">Bandeja / Airfryer combo</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-77">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-stone-700 text-sm font-bold" data-id="element-78">
                    3
                  </span>
                  <span className="text-lg" data-id="element-79">
                    Tacos / Wrap / Ensalada potente
                  </span>
                </li>
              </ul>
            </div>

            {/* 5 VARIATIONS */}
            <div className="bg-stone-800/50 backdrop-blur-sm p-8 rounded-2xl border border-stone-700" data-id="element-80">
              <div className="flex items-center gap-3 mb-6" data-id="element-81">
                <div className="p-3 bg-orange-500/20 rounded-xl text-orange-400" data-id="element-82">
                  <ChefHat className="w-6 h-6" data-id="element-83" />
                </div>
                <h3 className="text-2xl font-bold" data-id="element-84">5 Variaciones</h3>
              </div>
              <p className="text-stone-400 mb-6 text-sm uppercase tracking-wider" data-id="element-85">
                Cambios de sabor para no aburrirte
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-86">
                {['Tex-Mex', 'Mediterránea', 'Asian simple', 'BBQ "limpia"', 'Creamy alta-proteína'].map(tag => <span key={tag} className="px-4 py-2 bg-stone-700 rounded-full text-stone-200 text-sm font-medium" data-id="element-87">
                    {tag}
                  </span>)}
              </div>
              <div className="mt-8 pt-6 border-t border-stone-700" data-id="element-88">
                <p className="text-lg font-medium text-white" data-id="element-89">
                  Eliges 1 Base + 1 Variación ={' '}
                  <span className="text-emerald-400" data-id="element-90">Cena lista.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COMPARISON / WHY IT WORKS */}
      <section className="py-20 px-4 bg-[#F5F5F0]" data-id="element-91">
        <div className="max-w-5xl mx-auto" data-id="element-92">
          <div className="text-center mb-16" data-id="element-93">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-94">
              ¿Por qué esto funciona cuando lo demás falla?
            </h2>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-95">
              Elimina las dos cosas que te están saboteando: la fatiga de
              decisión y la fricción de cocinar.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-96">
            {/* OLD WAY */}
            <Card className="border-red-100 bg-red-50/50" data-id="element-97">
              <div className="flex items-center gap-2 mb-6 text-red-600 font-bold" data-id="element-98">
                <X className="w-6 h-6" data-id="element-99" />
                <span data-id="element-100">Lo que te está engordando</span>
              </div>
              <ul className="space-y-4 text-stone-700" data-id="element-101">
                <li className="flex items-start gap-3" data-id="element-102">
                  <span className="text-red-400 mt-1" data-id="element-103">•</span>
                  <span data-id="element-104">Cenas tarde y comes lo primero que aparece</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-105">
                  <span className="text-red-400 mt-1" data-id="element-106">•</span>
                  <span data-id="element-107">Repites 3–4 opciones "rápidas" que te inflaman</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-108">
                  <span className="text-red-400 mt-1" data-id="element-109">•</span>
                  <span data-id="element-110">Recetas "fit" con demasiados ingredientes</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-111">
                  <span className="text-red-400 mt-1" data-id="element-112">•</span>
                  <span data-id="element-113">
                    Te sientes culpable y al día siguiente "compensas"
                  </span>
                </li>
              </ul>
            </Card>

            {/* NEW WAY */}
            <Card className="border-emerald-200 bg-white ring-4 ring-emerald-50 shadow-xl relative overflow-hidden" data-id="element-114">
              <div className="absolute top-0 right-0 bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-115">
                MÉTODO 3+5
              </div>
              <div className="flex items-center gap-2 mb-6 text-emerald-700 font-bold" data-id="element-116">
                <CheckCircle2 className="w-6 h-6" data-id="element-117" />
                <span data-id="element-118">Tu nuevo sistema</span>
              </div>
              <ul className="space-y-4 text-stone-700" data-id="element-119">
                <li className="flex items-start gap-3" data-id="element-120">
                  <Check className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-121" />
                  <span data-id="element-122">
                    Repites ingredientes y estructura (ahorras dinero)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-123">
                  <Check className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-124" />
                  <span data-id="element-125">Cambias el sabor para no aburrirte nunca</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-126">
                  <Check className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-127" />
                  <span data-id="element-128">Cenas listas en 10–25 minutos reales</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-129">
                  <Check className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-130" />
                  <span data-id="element-131">Sostienes la semana sin sentirte a "dieta"</span>
                </li>
              </ul>
            </Card>
          </div>
        </div>
      </section>

      {/* WHO IS THIS FOR */}
      <section className="py-20 px-4 bg-white" data-id="element-132">
        <div className="max-w-3xl mx-auto text-center" data-id="element-133">
          <h2 className="font-serif text-3xl font-bold text-stone-900 mb-10" data-id="element-134">
            ¿Para quién es este método?
          </h2>
          <div className="grid sm:grid-cols-2 gap-4 text-left" data-id="element-135">
            {['Trabajas todo el día y llegas cansado/a', 'Quieres bajar grasa sin obsesionarte', 'Odias las recetas complicadas de 20 pasos', 'Quieres comer rico (no solo pollo hervido)', 'Necesitas un sistema repetible', 'Buscas resultados reales, no milagros'].map((item, i) => <div key={i} className="flex items-center gap-3 p-4 bg-stone-50 rounded-lg border border-stone-100" data-id="element-136">
                <div className="w-5 h-5 rounded-full bg-emerald-500 flex items-center justify-center text-white flex-shrink-0" data-id="element-137">
                  <Check className="w-3 h-3" data-id="element-138" />
                </div>
                <span className="text-stone-700 font-medium" data-id="element-139">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED (OFFER) */}
      <section id="offer" className="py-24 px-4 bg-emerald-900 text-white" data-id="element-140">
        <div className="max-w-5xl mx-auto" data-id="element-141">
          <div className="text-center mb-16" data-id="element-142">
            <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6" data-id="element-143">
              ¿Qué incluye exactamente?
            </h2>
            <p className="text-emerald-100 text-lg" data-id="element-144">
              Todo lo que necesitas para automatizar tus cenas.
            </p>
          </div>

          <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-145">
            {/* Product Image in Offer */}
            <div className="md:col-span-5 relative" data-id="element-146">
              <img src={productImageUrl} alt="Pack completo del método" className="w-full rounded-2xl shadow-2xl border-4 border-emerald-800/50 transform md:rotate-[-2deg]" data-id="element-147" />
              <div className="absolute -bottom-6 -right-6 bg-orange-500 text-white font-bold py-3 px-6 rounded-full shadow-lg transform rotate-3" data-id="element-148">
                Acceso Inmediato
              </div>
            </div>

            {/* Features List */}
            <div className="md:col-span-7 space-y-6" data-id="element-149">
              <div className="bg-emerald-800/50 p-6 rounded-2xl border border-emerald-700/50" data-id="element-150">
                <ul className="space-y-4" data-id="element-151">
                  <li className="flex items-start gap-4" data-id="element-152">
                    <BookOpen className="w-6 h-6 text-emerald-300 flex-shrink-0 mt-1" data-id="element-153" />
                    <div data-id="element-154">
                      <h4 className="font-bold text-lg" data-id="element-155">
                        El Método Completo 3+5
                      </h4>
                      <p className="text-emerald-200 text-sm" data-id="element-156">
                        La guía paso a paso para dominar el sistema.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-157">
                    <Utensils className="w-6 h-6 text-emerald-300 flex-shrink-0 mt-1" data-id="element-158" />
                    <div data-id="element-159">
                      <h4 className="font-bold text-lg" data-id="element-160">
                        Guía de Porciones Visuales
                      </h4>
                      <p className="text-emerald-200 text-sm" data-id="element-161">
                        Olvídate de pesar comida. Aprende a servirte a ojo.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-162">
                    <ChefHat className="w-6 h-6 text-emerald-300 flex-shrink-0 mt-1" data-id="element-163" />
                    <div data-id="element-164">
                      <h4 className="font-bold text-lg" data-id="element-165">
                        Biblioteca de Combinaciones
                      </h4>
                      <p className="text-emerald-200 text-sm" data-id="element-166">
                        Menús listos de "Elige 1 + 1" para no pensar.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-167">
                    <Calendar className="w-6 h-6 text-emerald-300 flex-shrink-0 mt-1" data-id="element-168" />
                    <div data-id="element-169">
                      <h4 className="font-bold text-lg" data-id="element-170">
                        Plan Semanal Flexible
                      </h4>
                      <p className="text-emerald-200 text-sm" data-id="element-171">
                        Dos modos: "Cero tiempo" y "Tiempo mínimo".
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-172">
                    <ShoppingBag className="w-6 h-6 text-emerald-300 flex-shrink-0 mt-1" data-id="element-173" />
                    <div data-id="element-174">
                      <h4 className="font-bold text-lg" data-id="element-175">
                        Lista de Compras Inteligente
                      </h4>
                      <p className="text-emerald-200 text-sm" data-id="element-176">
                        Compra solo lo que necesitas. Cero desperdicio.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="bg-white/5 p-6 rounded-2xl border border-white/10" data-id="element-177">
                <div className="flex items-center gap-2 mb-2 text-orange-300 font-bold text-sm uppercase tracking-wide" data-id="element-178">
                  <Star className="w-4 h-4" data-id="element-179" /> Bonus Incluido
                </div>
                <h4 className="font-bold text-xl mb-2" data-id="element-180">
                  Protocolo de Emergencia
                </h4>
                <p className="text-emerald-100" data-id="element-181">
                  Reglas para antojos, cenas tarde, fines de semana y qué hacer
                  si te estancas.
                </p>
              </div>

              <div className="pt-4" data-id="element-182">
                <Button variant="secondary" size="xl" fullWidth className="text-lg shadow-orange-900/20" id="pricing" onClick={handleBuyClick} data-id="element-183">
                  Descargar Ahora - $6.39 USD
                </Button>
                <p className="text-center text-emerald-300 text-sm mt-4" data-id="element-184">
                  Pago único. Acceso de por vida. Garantía de satisfacción.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ / OBJECTION HANDLING */}
      <section className="py-20 px-4 bg-white" data-id="element-185">
        <div className="max-w-3xl mx-auto" data-id="element-186">
          <h2 className="font-serif text-3xl font-bold text-center mb-12" data-id="element-187">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-8" data-id="element-188">
            <div data-id="element-189">
              <h3 className="font-bold text-xl mb-2 flex items-center gap-2" data-id="element-190">
                <span className="text-emerald-600" data-id="element-191">?</span> "Pero… ¿sin contar
                calorías de verdad?"
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-192">
                Sí. No porque las calorías "no importen", sino porque para gente
                ocupada contar calorías suele ser una trampa mental. Aquí usas
                porciones visuales, composición del plato y proteína suficiente
                para saciedad. Comes con orden… sin la locura del número.
              </p>
            </div>

            <div data-id="element-193">
              <h3 className="font-bold text-xl mb-2 flex items-center gap-2" data-id="element-194">
                <span className="text-emerald-600" data-id="element-195">?</span> "¿Necesito una
                Airfryer obligatoriamente?"
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-196">
                No es obligatoria, pero la recomendamos porque ahorra tiempo.
                Todas las recetas incluyen instrucciones para horno convencional
                o sartén. El sistema funciona por la estructura, no por el
                electrodoméstico.
              </p>
            </div>

            <div data-id="element-197">
              <h3 className="font-bold text-xl mb-2 flex items-center gap-2" data-id="element-198">
                <span className="text-emerald-600" data-id="element-199">?</span> "¿Sirve para toda la
                familia?"
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-200">
                Absolutamente. Las bases son comida real (pollo, carne, pescado,
                vegetales, arroz, papas). Simplemente ajustas las cantidades
                para tu pareja o hijos. No tienes que cocinar dos menús
                diferentes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-24 px-4 bg-stone-50 border-t border-stone-200" data-id="element-201">
        <div className="max-w-4xl mx-auto text-center" data-id="element-202">
          <h2 className="font-serif text-4xl font-bold text-stone-900 mb-8" data-id="element-203">
            Imagina esto en tu semana
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 text-left max-w-3xl mx-auto" data-id="element-204">
            <div className="p-4 bg-white rounded-xl shadow-sm border border-stone-100" data-id="element-205">
              <span className="block text-2xl mb-2" data-id="element-206">📂</span>
              <p className="font-medium text-sm" data-id="element-207">Abres el PDF</p>
            </div>
            <div className="p-4 bg-white rounded-xl shadow-sm border border-stone-100" data-id="element-208">
              <span className="block text-2xl mb-2" data-id="element-209">point_up</span>
              <p className="font-medium text-sm" data-id="element-210">Eliges Base + Variación</p>
            </div>
            <div className="p-4 bg-white rounded-xl shadow-sm border border-stone-100" data-id="element-211">
              <span className="block text-2xl mb-2" data-id="element-212">🍳</span>
              <p className="font-medium text-sm" data-id="element-213">Cocinas rápido</p>
            </div>
            <div className="p-4 bg-white rounded-xl shadow-sm border border-stone-100" data-id="element-214">
              <span className="block text-2xl mb-2" data-id="element-215">😴</span>
              <p className="font-medium text-sm" data-id="element-216">Duermes sin culpa</p>
            </div>
          </div>

          <p className="text-xl text-stone-600 mb-10" data-id="element-217">
            No porque ahora eres otra persona… sino porque tu sistema por fin te
            ayuda.
          </p>

          <div className="inline-block relative group" data-id="element-218">
            <div className="absolute -inset-1 bg-gradient-to-r from-emerald-500 to-orange-500 rounded-full blur opacity-25 group-hover:opacity-50 transition duration-200" data-id="element-219"></div>
            <Button size="xl" onClick={scrollToOffer} className="relative w-full md:w-auto px-12" data-id="element-220">
              Empezar hoy mismo
            </Button>
          </div>
          <p className="mt-6 text-sm text-stone-500" data-id="element-221">
            Descarga digital inmediata • Acceso seguro
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-white py-12 px-4 border-t border-stone-100" data-id="element-222">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 text-stone-500 text-sm" data-id="element-223">
          <p data-id="element-224">© 2024 Método 3+5. Todos los derechos reservados.</p>
          <div className="flex gap-6" data-id="element-225">
            <button onClick={() => setActiveModal('terms')} className="hover:text-stone-900 transition-colors" data-id="element-226">
              Términos
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-stone-900 transition-colors" data-id="element-227">
              Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* TERMS MODAL */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-228">
        <p data-id="element-229">
          <strong data-id="element-230">Última actualización:</strong> Enero 2024
        </p>
        <p data-id="element-231">
          Al adquirir el producto digital "Método 3 Bases + 5 Variaciones",
          aceptas los siguientes términos y condiciones de uso.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-232">
          1. Producto Digital
        </h3>
        <p data-id="element-233">
          Este es un producto digital en formato PDF. Una vez completada la
          compra, recibirás acceso inmediato al contenido descargable. Debido a
          la naturaleza digital del producto, no se aceptan devoluciones una vez
          descargado el archivo.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-234">
          2. Uso Personal
        </h3>
        <p data-id="element-235">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución, reventa o compartición
          del material, ya sea parcial o total, sin autorización expresa por
          escrito.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-236">
          3. Propiedad Intelectual
        </h3>
        <p data-id="element-237">
          Todo el contenido, incluyendo textos, diseños, gráficos y metodología,
          es propiedad intelectual de Método 3+5. Está protegido por las leyes
          de derechos de autor aplicables.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-238">
          4. Descargo de Responsabilidad
        </h3>
        <p data-id="element-239">
          La información proporcionada en este producto es de carácter educativo
          e informativo. No sustituye el consejo médico o nutricional
          profesional. Consulta a un profesional de la salud antes de realizar
          cambios significativos en tu alimentación. Los resultados pueden
          variar según cada persona.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-240">
          5. Modificaciones
        </h3>
        <p data-id="element-241">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor a partir de su
          publicación en esta página.
        </p>
      </Modal>

      {/* PRIVACY MODAL */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-242">
        <p data-id="element-243">
          <strong data-id="element-244">Última actualización:</strong> Enero 2024
        </p>
        <p data-id="element-245">
          Tu privacidad es importante para nosotros. Esta política describe cómo
          recopilamos, usamos y protegemos tu información personal.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-246">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-247">
          Al realizar una compra, recopilamos únicamente la información
          necesaria para procesar tu pedido: nombre, dirección de correo
          electrónico e información de pago. La información de pago es procesada
          de forma segura por nuestro proveedor de pagos y no almacenamos datos
          de tarjetas de crédito.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-248">
          2. Uso de la Información
        </h3>
        <p data-id="element-249">Utilizamos tu información exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-250">
          <li data-id="element-251">Procesar y entregar tu compra</li>
          <li data-id="element-252">Enviarte el enlace de descarga del producto</li>
          <li data-id="element-253">Comunicarnos contigo sobre tu pedido si es necesario</li>
        </ul>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-254">
          3. Protección de Datos
        </h3>
        <p data-id="element-255">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-256">
          4. No Compartimos tu Información
        </h3>
        <p data-id="element-257">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. La única excepción es nuestro procesador de pagos, que
          necesita los datos mínimos para completar la transacción.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-258">5. Cookies</h3>
        <p data-id="element-259">
          Este sitio puede utilizar cookies para mejorar la experiencia del
          usuario y analizar el tráfico del sitio. Puedes desactivar las cookies
          en la configuración de tu navegador.
        </p>
        <h3 className="font-bold text-stone-900 text-base pt-2" data-id="element-260">
          6. Tus Derechos
        </h3>
        <p data-id="element-261">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, puedes
          comunicarte con nosotros.
        </p>
      </Modal>
    </div>;
}